import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../router/all_routes";
import { getAllUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { formatAccountsData } from "../../../../utils/helpers/formatModulesData";
import { setFilterModel } from "../../../../core/data/redux/filterSlice";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import { customMuiDateFilter } from "../../../../utils/helpers/customMuiDateFilter";

const AccountList = ({ accountsData }) => {
  const route = all_routes;
  const dispatch = useDispatch();

  const allParams = getAllUrlParams(); // Get all URL params
  const queryString = new URLSearchParams(allParams).toString();
  const filterModel = useSelector((state) => state.filter.filterModel);

  const processedRows = formatAccountsData(accountsData);

  // Columns definition for the DataGrid
  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 210,
      sortable: true,
      renderCell: (params) => {
        const accountDetailsUrl = `${route.accountDetails.replace(
          ":id",
          params.row.id
        )}?${queryString}`;

        return (
          <Link className="list-link text-capitalize" to={accountDetailsUrl}>
            {params.row.firstName} {params.row.lastName}
          </Link>
        );
      },
    },
    {
      field: "ofCompany",
      headerName: "Company",
      width: 210,
      renderCell: (params) => (
        <div className="text-capitalize">{params?.row?.ofCompany}</div>
      ),
      sortable: true,
    },

    { field: "email", headerName: "Email", width: 210, sortable: true },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 210,
      valueFormatter: (params) =>
        params?.value ? convertToUTCString(params?.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.createdAt
            ? convertToUTCString(params?.row?.createdAt)
            : convertToUTCString(params?.row?.updatedAt)}
        </div>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 210,
      valueFormatter: (params) =>
        params.value ? convertToUTCString(params.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.updatedAt
            ? convertToUTCString(params?.row?.updatedAt)
            : convertToUTCString(params?.row?.createdAt)}
        </div>
      ),
    },

    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   renderCell: (params) => (
    //     <ActionsDropdown
    //       params={params}
    //       module={MODULES.DEALS}
    //       path={route.accountDetails}
    //     />
    //   ),
    //   sortable: false,
    // },
  ];

  return (
    <div style={{ width: "100%" }}>
      {/* DataGrid Table */}
      <DataGrid
        rows={processedRows}
        columns={columns.map((column) => ({
          ...column,
          headerClassName: "bg-light-200",
        }))}
        autoHeight
        hideFooter
        disableExtendRowFullWidth
        onStateChange={(state) => {
          const filteredRowIds = Object.entries(state.filter.filteredRowsLookup)
            .filter(([_, isVisible]) => isVisible === true)
            .map(([rowId]) => rowId); // Keep IDs as strings

          // Filter accountsData based on these IDs
          const filteredData = accountsData?.filter((row) =>
            filteredRowIds.includes(row?._id)
          );
          // Pass the filtered data to the parent
          // setFilteredData(filteredData);
        }}
        sx={{
          "& .sticky-column": {
            position: "sticky",
            right: 0,
            background: "white", // Prevents content from hiding under it
            zIndex: 100, // Keeps it on top
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "white",
            position: "sticky",
            top: 0,
            zIndex: 110,
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
        }}
        filterModel={filterModel}
        onFilterModelChange={(newModel) => dispatch(setFilterModel(newModel))}
        slots={{
          toolbar: GridToolbar, // Enable filter toolbar above the grid
        }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true }, // Hide Print Button
            csvOptions: { disableToolbarButton: true }, // Hide CSV Export
          },
        }}
      />
    </div>
  );
};

export default AccountList;
